@if (!isLoading()) {
<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NEW-CHAT.createANewGroupChannel' | alternateTranslation | translate | uppercase }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="newChatForm">
    <mat-form-field appearance="fill" class="full-width-input">
      <input matInput placeholder="{{ 'groupName' | alternateTranslation | translate }}" formControlName="displayName" />
    </mat-form-field>
    <ngx-users-search
      [useGroups]="true"
      [showFilterInput]="true"
      [usersSelected]="usersSelected"
      (usersSelectedChange)="usersSelected = $event"></ngx-users-search>
    @if (usersSelected?.length) {
    <ngx-users-selected [usersSelected]="usersSelected" (usersSelectedChange)="usersSelected = $event"></ngx-users-selected>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="chat-input__button"
    color="primary"
    (click)="createChannel()"
    [disabled]="!newChatForm.valid || !usersSelected.length">
    {{ 'createGroup' | alternateTranslation | translate }}
  </button>
</div>
} @else {
<ngx-text-spinner [text]="'loadingGroupChannelCreation' | alternateTranslation | translate"></ngx-text-spinner>
}
